/**
 * @param $scope
 * @param {AppConfig} appConfig
 * @param {UserService} userService
 */
const ErrorCtrl = function (
    $scope,
    appConfig,
    userService
) {
    $scope.user = userService;
    $scope.appConfig = appConfig;
};

module.exports = ErrorCtrl;
